module.exports = __webpack_public_path__ + "static/media/5.3b3a7e26.jpg";